import { DataBean } from "../DataBean";

export class LabourType extends DataBean {

    // public async getLabourTypeCatalog(idLabourType: number): Promise<any> {
    //     return this.getCustomService("QuickDataERPCore", "java.util.List_getLabourTypeCatalog_Number", [idLabourType]);
    // }

    public async getLabourTypeCatalog(type: any,regexStr:any,page:any,recordsPerPage): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getLabourTypeCatalog_Number_String_Number_Number", [type,regexStr,page,recordsPerPage]);
    }

    public async getLabourTypeConstants(arg: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getLabourTypeConstants_Number", [arg]);
    }

}
